import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { makeStyles } from 'tss-react/mui';
import TextInput from '../ReusableComponents/TextInput/TextInput';

const useStyles = makeStyles()(() => ({
  root: {
    marginRight: '20px',
    width: '100%',
  },
}));

export default function ReEnterBankField(props) {
  const {
    label,
    name,
    parentValue = '',
    formHelperText = '',
    onChange = () => {},
    onBlur = () => {},
  } = props;
  const { classes } = useStyles();
  const [value, setValue] = useState('');
  const [error, setError] = useState(
    !isEmpty(parentValue) && value !== parentValue,
  );

  useEffect(() => {
    onChange(name, value);
  }, [value]);

  const handleChange = (e) => {
    e.persist();

    setError(false);
    setValue(e.target.value);
  };

  const handleBlur = (e) => {
    e.persist();

    if (isEmpty(value) || e.target.value !== parentValue) setError(true);

    setValue(e.target.value);

    onBlur(e);
  };

  return (
    <TextInput
      fullWidth
      className={classes.root}
      required
      error={error}
      label={label}
      variant="outlined"
      name={name}
      onChange={handleChange}
      onBlur={handleBlur}
      onPaste={(e) => e.preventDefault()}
      value={value}
      formHelperText={
        error && <span style={{ color: 'red' }}>{formHelperText}</span>
      }
      autoComplete="no"
    />
  );
}

ReEnterBankField.propTypes = {
  parentValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  formHelperText: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};
